import { GoogleMap, Marker, InfoWindow, useLoadScript } from '@react-google-maps/api';
import react, { useEffect, useRef, useState, useCallback } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridColDef, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton, GridValueGetterParams, getGridStringOperators, } from "@mui/x-data-grid";
import styled from "styled-components";
import CloseIcon from '@mui/icons-material/Close';
import Drawer from "../../components/common/drawer/drawer";
import { Typography, Button, Checkbox, Fab, IconButton, FormControl, InputLabel, Stack, Select, MenuItem, Modal, Dialog, DialogActions, DialogContent, DialogTitle, Autocomplete, TextField, Paper, InputAdornment } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { ERROR_COLOR } from "../../constants";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Add, Save, SaveAlt, Search } from "@mui/icons-material";
import WarehouseModal from "../../components/modals/orderLineItemModal";
import clearFilterImage from "../../../src/icons/clearFilter.svg";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useLocation } from 'react-router-dom';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import * as XLSX from "xlsx";
import axios from "axios";
import { CloseOutlined } from "@mui/icons-material";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import TodayPunchModal from "../../components/modals/TodayPunchModal";
import { borderBottom, fontWeight, height, padding, width } from "@mui/system";
import searchIcon from "../../icons/searchIcon.svg";
import { is } from 'date-fns/locale';
const isMobile = window.innerWidth < 900;
const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
  `
      position: relative;
  
      `}
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${isMobile ? "column" : "row"};
`;
const HeaderButtonsContainer = styled.div`
  ${isMobile && "margin-top:10px;"}
`;

const TableContainer = styled.div`
// height: calc(
//   100vh - ${isMobile ? "56px - 20px - 82.23px" : "112px - 34px - 43.77px"}
// );
  width: 100%;
  // border: solid 1px lightGrey;
  border-radius: 8px;
`;
const AvatarContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: 100%;
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? 'flex' : 'grid'};

  ${isMobile &&
  `
    flex-direction: column;
  `}
`;
const LoadingContainer = styled.div`
  height: calc(100% - 49px);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const TabsContainer = styled.div`
  ${isMobile &&
  `
    height: calc(100vh - 56px - 20px);
  `}
`;
const GenerateReportButton = styled(Button)`
  margin-right: 10px !important;
`;
const BulkChangePinCodeButton = styled(Button)`
  margin-right: 10px !important;
`;
const PinCodeChangeButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const FabStyle = styled(Fab)`
  && {
    z-index: 1};
  }
`;
const StyledHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export default function LocationManagement() {
  // Helper to format time in 12-hour format
  const formatTime12 = (timeStr) => {
    if (!timeStr) return "N/A";
    const [hour, minute] = timeStr.split(":");
    let h = parseInt(hour, 10);
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12;
    if (h === 0) h = 12;
    return `${h}:${minute} ${ampm}`;
  };
  const apiRef = useRef();
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [loading, setLoading] = useState(false);
  const [accessChanges, setAccessChanges] = useState("");
  const [rowCount, setRowCount] = useState()
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationModel, setPaginationModel] = useState({
    page: currentPage - 1,
    pageSize: 20,
  });
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [filter, setFilter] = useState(false)
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [asms, setAsms] = useState([]);
  const [search, setSearch] = useState()
  const [rms, setRms] = useState([]);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [rejectData, setRejectData] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [reason, setReason] = useState("");
  const [partyType, setPartyType] = useState("all");
  const [newOrderStatus, setNewOrderStatus] = useState(0);
  const [openLocationViewModal, setOpenLocationViewModal] = useState(false);
  const [locationModalData, setLocationModalData] = useState({});
  const [openPartyModal, setOpenPartyModal] = useState(false);
  const [openPartyBModal, setOpenPartyBModal] = useState(false);
  const [dropdownData, setDropdownData] = useState({ medium: [], board: [], grade: [], makerRole: [] });
  const [partyViewData, setPartyViewData] = useState({});
  const [openUserModal, setOpenUserModal] = useState(false);
  const [viewUserData, setViewUserData] = useState({});
  const [openVisitModal, setOpenVisitModal] = useState(false);
  const [visitViewData, setVisitViewData] = useState({});
  const [openPartyAdditionModal, setOpenPartyAdditionModal] = useState(false);
  const [partyAdditionViewData, setPartyAdditionViewData] = useState({});
  const [minTimeValue, setMinTimeValue] = useState("");
  const [mainFilter, setMainFilter] = useState("");
  const [mainFilterList, setMainFilterList] = useState([]);
  const [nameForHead, setNameForHead] = useState("");
  const [rowDataOfModal, setRowDataOfModal] = useState({});
  const [hoveredAuditor, setHoveredAuditor] = useState(null);
  const [auditorLocations, setAuditorLocations] = useState([])
  const [infoWindowHovered, setInfoWindowHovered] = useState(false);
  const [schoolDataBasedOnId, setSchoolDataBasedOnId] = useState([]);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [openReleaseDialog, setOpenReleaseDialog] = useState(false);
  const [rowDataForRelease, setRowDataForRelease] = useState({});
  const [releaseReason, setReleaseReason] = useState("");
    const [accessModulesData, setAccessModulesData] = useState([]);
  const { isLoaded } = useLoadScript({
    // googleMapsApiKey: 'AIzaSyBmaS0B0qwokES4a_CiFNVkVJGkimXkNsk'
    googleMapsApiKey: 'AIzaSyCMIjqkbWwEUD4GCRv9HhfD8cpTQ4DWbvQ'
  });

  // For Party Update Modal: handle select all and row select
  const handleSelectAll = (e, fields) => {
    setSelectAll(e.target.checked);
    if (e.target.checked) {
      setSelectedRows(fields.map((_, idx) => idx));
    } else {
      setSelectedRows([]);
    }
  };
  const handleRowSelect = (idx, fields) => {
    setSelectedRows(prev => {
      if (prev.includes(idx)) {
        return prev.filter(i => i !== idx);
      } else {
        return [...prev, idx];
      }
    });
  };
  // Sync selectAll when all rows are selected
  useEffect(() => {
    // Only run when PartyBModal is open
    if (openPartyBModal) {
      let data = rowDataOfModal?.data;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (e) { data = {}; }
      }
      let distributor = data?.distributor;
      if (typeof distributor === 'string') {
        try { distributor = JSON.parse(distributor); } catch (e) { distributor = distributor; }
      }
      const fields = [
        { label: 'School ID' },
        { label: 'School Name' },
        { label: 'Email' },
        { label: 'Board' },
        { label: 'Grade' },
        { label: 'Medium' },
        { label: 'Contact Person Role' },
        { label: 'Contact Person Name' },
        { label: 'Contact Person Number' },
        { label: 'Distributor' },
        { label: 'Address Line 1' },
        { label: 'Address Line 2' },
        { label: 'Pincode' },
      ];
      if (selectedRows.length === fields.length) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }
    }
  }, [selectedRows, openPartyBModal]);

  // const updatePartyBModal = async (output) => {
  //   setLoading(true);
  //   let payload = {
  //     output: output,
  //     partyData: rowDataOfModal?.partyData,
  //     party_type: rowDataOfModal?.partyType,
  //     requestId: rowDataOfModal?.id,
  //     request_type_id: rowDataOfModal?.request_type_id,
  //     status: "1"
  //   }

  //   let results = await window.Platform.database.PartyUpdate(payload);
  //   if (results.success) {
  //     window.NotificationUtils.showSuccess(results?.message);
  //     setLoading(false)
  //     fetchLocation();
  //     setOpenPartyModal(false);
  //     setLoading(false);
  //   }
  //   else {
  //     window.NotificationUtils.showError(results?.message);
  //     setLoading(false)
  //     return;
  //   }
  // }
       const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId : userData?.id,
                moduleId : "wzxRdAXFxK"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }

  const updatePartyBModal = async (output) => {
    // setLoading(true);
    console.log(output, "output11", rowDataOfModal)
    // return;
    const confirmUpdate = window.confirm(
      "Are you sure to update these records for School? It will replace the original entry in the database which cannot be reversed. Do you want to proceed?"
    );
    if (!confirmUpdate) {
      setLoading(false);
      return;
    }

    try {
      const payload = {
        output: output,
        partyData: rowDataOfModal?.partyData,
        party_type: rowDataOfModal?.partyType,
        requestId: rowDataOfModal?.id,
        request_type_id: rowDataOfModal?.request_type_id,
        status: "1"
      };

      const results = await window.Platform.database.PartyUpdate(payload);

      if (results?.success) {
        window.NotificationUtils.showSuccess(results?.message || "Updated Successfully");
        fetchLocation();
        setOpenPartyBModal(false);
        setSelectedRows([]);
        setSelectAll(false);
        setLoading(false);
      } else {
        window.NotificationUtils.showError(results?.message || "Failed to update party");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error updating party:", error);
      window.NotificationUtils.showError("An unexpected error occurred. Please try again.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const location = useLocation();
  let request_type_id = location.state?.request_type_id || null;

  const containerStyle = {
    width: '100%',
    height: '600px'
  };

  const center = {
    lat: 28.6139,
    lng: 77.2090
  };
  useEffect(() => {
    if(location.state?.request_type_id){
      setHasSearched(true);
    }
    if (hasSearched) {
      fetchLocation();
    }
  }, [paginationModel.page, paginationModel.pageSize, partyType, newOrderStatus, mainFilter]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(handler);
  }, [search]);

  useEffect(() => {
    if (hasSearched || request_type_id) {
      const fetchData = async () => {
        setMainFilter(29);
        try {
          setLoading(true);
          let data = {
            ownerName: rm,
            asm: userData?.role === 'asm' ? userData?.id : asm,
            rsm: userData?.role === 'rsm' ? userData?.id : rsm,
            party_type: partyType,
            status: newOrderStatus,
            pageNumber: paginationModel.page,
            recordPerPage: paginationModel.pageSize,
            request_type_id: request_type_id
          };
          let results = await window.Platform.database.getRequestTableList(data);
          if (results?.status) {
            setRowCount(results.data1);
            const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
            setAccessChanges(jsonArrayWithId);
          }
          else {
            setRowCount(0);
            setAccessChanges([]);
            window.NotificationUtils.showError("Error Fetching Data");
          }
        } catch (error) {
          console.error(error);
          window.NotificationUtils.showError("Error Fetching Data");
        } finally {
          setLoading(false);
        }
      };
      fetchData();
      return () => {
        setLoading(false);
      };
    }
  }, [request_type_id]);


  useEffect(() => {
    fetchAccessModules();
    setLoading(true);
    getAllDataForDropdownParty()
    if (location.state && location.state.request_type_id) {
      setMainFilter(location.state.request_type_id);
    } else {
      setMainFilter("");
    }
    getRequestTypeList()
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers()
    }
    if (userData?.role == 'rsm') {
      getUsers('rsm', userData?.id)
    }
    if (userData?.role == 'asm') {
      getUsers('asm', userData?.id)
    }
  }, [])

  // useEffect(() => {
  //   fetchLocation();
  // }, [debouncedSearch]);

  // useEffect(() => {
  //   if (location.state && location.state.request_type_id) {
  //     setMainFilter(location.state.request_type_id);
  //   } else {
  //     setMainFilter("");
  //   }
  // }, []);

  //   const handleSelectAll = (event, fields) => {
  //   if (event.target.checked) {
  //     setSelectedRows(fields?.map((_, idx) => idx)); // select all by index
  //     setSelectAll(true);
  //   } else {
  //     setSelectedRows([]);
  //     setSelectAll(false);
  //   }
  // };

  // const handleRowSelect = (index) => {
  //   let updated = [...selectedRows];
  //   if (updated?.includes(index)) {
  //     updated = updated?.filter(i => i !== index);
  //   } else {
  //     updated.push(index);
  //   }
  //   setSelectedRows(updated);
  //   setSelectAll(updated?.length == selectedRows?.length); // update select all state
  // };

  const fetchLocation = async () => {
    try {
      setLoading(true);
      let data = {
        ownerName: rm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        party_type: partyType,
        status: newOrderStatus,
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        filter: search || "",
        // status:mainFilter,
        request_type_id: mainFilter
      }
      let results = await window.Platform.database.getRequestTableList(data);
      if (results?.status) {
        setRowCount(results.data1);
        const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
        setAccessChanges(jsonArrayWithId);
        setLoading(false);
      }
      else {
        setAccessChanges([]);
        window.NotificationUtils.showError("Error Fetching Data");
        setLoading(false);
      }

    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
    }
    finally {
      setLoading(false)
    }
  }

  const getAllDataForDropdownParty = async () => {
    try {
      setLoading(true);
      let results = await window.Platform.database.getAllDataForDropdownParty({});
      if (results?.status) {
        window.NotificationUtils.showError("Error Fetching Data getAllDataForDropdownParty");
      }
      else {
        setDropdownData({
          medium: results.data.medium || [],
          board: results.data.board || [],
          grade: results.data.grade || [],
          makerRole: results.data.makerRole || [],
        });
      }
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
    } finally {
      setLoading(false)
    }
  }

  const getRequestTypeList = async () => {
    setLoading(true);
    let results = await window.Platform.database.getRequestTypeList();
    if (results?.status) {
      setMainFilterList(results?.data);
      setLoading(false);
    }
    else {
      setMainFilterList([])
      setLoading(false);
    }

  }

  const fetchVisit = useCallback(async () => {
    setLoading(true);
    setLoading(false);
  }, []);

  const getSpecimenRequest = useCallback(async () => {
    setLoading(true);
    setLoading(false);
  }, []);

  const fetchBaseLocation = useCallback(async () => {
    setLoading(true);
    setLoading(false);
  }, []);

  // const clearFilters = async () => {
  //   setLoading(true);
  //   setRm("")
  //   setRsm("")
  //   setAsm("")
  //   setPaginationModel((prev) => ({ ...prev, pageSize: 20 }))
  //   setPartyType("all");
  //   try {
  //     let data = {
  //       ownerName: rm,
  //       asm: "",
  //       rsm: "",
  //       party_type: "all",
  //       status: "all",
  //       pageNumber: 0,
  //       recordPerPage: 20
  //     }
  //     let results = await window.Platform.database.getPartyLocation(data);
  //     setRowCount(results.data1);
  //     const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
  //     setAccessChanges(jsonArrayWithId);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error(error);
  //     window.NotificationUtils.showError("Error Fetching Data");
  //     setLoading(false);
  //   }
  //   finally {
  //     setLoading(false)
  //   }
  // }

  const downloadUserRequestExcel = async () => {
    setLoading(true);
    const requestTypeObj = mainFilterList.find(item => String(item.id) === String(mainFilter));
    const requestTypeName = requestTypeObj ? requestTypeObj.name : mainFilter;
    try {
      let data = {
        ownerName: rm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        party_type: partyType,
        status: newOrderStatus,
        filter: search || "",
        request_type_id: mainFilter
      }
      let result = await window.Platform.database.exportData("party/downloadRequestTableExcel",
        data
      )
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const now = new Date();
      const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `User_Reqest_${requestTypeName}_${formattedDate}.xlsx`);
      // link.setAttribute("download", "attendance.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }

  const clearFilters = async () => {
    setLoading(true);
    setRm("");
    setRsm("");
    setAsm("");
    setSearch("");
    setPaginationModel((prev) => ({ ...prev, pageSize: 20 }));
    setMainFilter("")
    setNewOrderStatus(0)
    setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
    setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
    setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
    // setPartyType("all");
    try {
      let data = {
        ownerName: "",
        asm: "",
        rsm: "",
        party_type: "all",
        request_type_id: "",
        filter: "",
        status: 0,
        pageNumber: 0,
        recordPerPage: 20
      };
      // let results = await window.Platform.database.getRequestTableList(data);
      // setRowCount(results.data1);
      // const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
      // setAccessChanges(jsonArrayWithId);
      setLoading(false);
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleReject = (data) => {
    setRejectData(data);

    setOpenDialog(true);
  };

  const handleConfirmReject = () => {
    if (reason.trim() === "") {
      window.NotificationUtils.showError("Remark is required to reject the order.")
      return;
    }
    approveRejectOrder({ ...rejectData, reason });
    setOpenDialog(false);
    setReason("");
    setRejectData(null);
  };

  const handleConfirmRejectRelease = async () => {
    if (releaseReason.trim() === "") {
      window.NotificationUtils.showError("Remark is required to Release This Party.")
      return;
    }
    console.log(rowDataForRelease, "rowDatarowDatarowData");
    // return;
    try {
      setLoading(true);
      if (rowDataForRelease?.min_time == "party") {
        const payload = {
          id: rowDataForRelease?.id,
          status: "3",
          partyAddressId: rowDataForRelease?.request_id,
          party_type: rowDataForRelease?.DistributorNameForLocation ? "distributor" : rowDataForRelease?.schoolNameForLocation ? "school" : "",
          latlong_release_remark: releaseReason
        }
        // console.log(payload,"oiuyoieweyeroiweyroaer")
        // return;
        const result = await window.Platform.database.ReleasePartyLocation(payload);
        if (result?.success) {
          window.NotificationUtils.showError(result?.message || "Release failed!");
        } else {
          window.NotificationUtils.showSuccess(result?.message || "Released successfully!");
          fetchLocation();
          setOpenReleaseDialog(false);
          setReleaseReason("");
        }
      }
      else if (rowDataForRelease?.min_time == "user") {
        const payload = {
          userId: rowDataForRelease?.request_id,
          status: "3",
          id: rowDataForRelease?.id
        }
        // console.log(payload,"asdhasodhoudgodeg")
        // return;
        const result = await window.Platform.database.releaseUserLocation(payload);

        if (result?.status) {
          window.NotificationUtils.showError(result?.message || "Release failed!");
        } else {
          window.NotificationUtils.showSuccess(result?.message || "Released successfully!");
          fetchLocation();
          setOpenReleaseDialog(false);
          setReleaseReason("");
        }
      }
      else if (rowDataForRelease?.min_time == "userA") {
        const payload = {
          userId: rowDataForRelease?.request_id,
          status: "3",
          id: rowDataForRelease?.id
        }
        // console.log(payload,"asdhasodhoudgodeg")
        // return;
        const result = await window.Platform.database.releaseUserLocation(payload);

        if (result?.status) {
          window.NotificationUtils.showError(result?.message || "Release failed!");
        } else {
          window.NotificationUtils.showSuccess(result?.message || "Released successfully!");
          fetchLocation();
        }
      }

    } catch (error) {
      window.NotificationUtils.showError("Error releasing party location!");
    } finally {
      setLoading(false);
    }
  };

  // Add updateDistributor function for distributor update
  const updateDistributor = async (output) => {
    setLoading(true);
    const confirmUpdate = window.confirm(
      "Are you sure to update these records for Distributor? It will replace the original entry in the database which cannot be reversed. Do you want to proceed?"
    );
    if (!confirmUpdate) {
      setLoading(false);
      return;
    }
    try {
      const payload = {
        output: output,
        partyData: rowDataOfModal?.partyData,
        party_type: rowDataOfModal?.partyType,
        requestId: rowDataOfModal?.id,
        request_type_id: rowDataOfModal?.request_type_id,
        status: "1"
      };
      const results = await window.Platform.database.updateDistributor(payload);
      if (results?.success) {
        window.NotificationUtils.showSuccess(results?.message || "Distributor Updated Successfully");
        fetchLocation();
        setOpenPartyBModal(false);
        setSelectedRows([]);
        setSelectAll(false);
        setLoading(false);
      } else {
        window.NotificationUtils.showError(results?.message || "Failed to update distributor");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error updating distributor:", error);
      window.NotificationUtils.showError("An unexpected error occurred. Please try again.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const approveRejectOrder = async (val) => {
    try {
      setLoading(true)
      let party_type = "";
      const min_time = val?.data?.min_time;
      if (min_time === "partyA") {
        if (val?.data?.partyData?.distributorID) {
          party_type = "distributor";
        } else if (val?.data?.partyData?.schoolId) {
          party_type = "school";
        }
      } else if (min_time === "party") {
        if (val?.data?.schoolIdForLocation) {
          party_type = "school";
        } else if (val?.data?.distributorIDForLocation) {
          party_type = "distributor";
        }
      }
      else if (min_time === "partyB") {
        if (val?.data?.partyType === "school") {
          party_type = "school";
        } else if (val?.data?.partyType === "distributor") {
          party_type = "distributor";
        }
      }
      let payload;
      let results;
      if (min_time === "partyB") {
        payload = {
          party_type,
          requestId: val?.data?.id,
          request_type_id: val?.data?.request_type_id,
          status: val.status,
          partyData: val?.data?.partyData,
          data: val?.data?.data,
          remark: val?.reason
        };
        results = await window.Platform.database.PartyUpdate(payload)
      } else {
        payload = {
          requestId: val?.data?.id,
          status: val.status,
          party_type,
          remark: val?.reason,
          request_type_id: val?.data?.request_type_id,
        };
        results = await window.Platform.database.updateLatLongApprovalStatus(payload)
      }
      // console.log(val, "payload", payload);
      // setLoading(false);
      // return;
      if (results.success) {
        window.NotificationUtils.showSuccess(results?.message);
        setLoading(false)
        fetchLocation();
        setOpenPartyModal(false);
        setOpenUserModal(false);
        setOpenVisitModal(false);
        setPartyAdditionViewData(false);
      }
      else {
        window.NotificationUtils.showError(results?.message);
        setLoading(false)
        return;
      }
    }
    catch (err) {
      console.log(err)
      window.NotificationUtils.showError("Something Went Wrong!");
      setLoading(false)
    }
  }

  // const handleReleasePartyLocation = async (rowData) => {
  //   console.log(rowData, "rowDatarowDatarowData");
  //   // return;
  //   try {
  //     setLoading(true);
  //     if (rowData?.min_time == "party") {
  //       const payload = {
  //         id: rowData?.id,
  //         status: "3",
  //         partyAddressId: rowData?.request_id,
  //         party_type: rowData?.DistributorNameForLocation ? "distributor" : rowData?.schoolNameForLocation ? "school" : ""
  //       }
  //       // console.log(payload,"oiuyoieweyeroiweyroaer")
  //       // return;
  //       const result = await window.Platform.database.ReleasePartyLocation(payload);
  //       if (result?.success) {
  //         window.NotificationUtils.showError(result?.message || "Release failed!");
  //       } else {
  //         window.NotificationUtils.showSuccess(result?.message || "Released successfully!");
  //         fetchLocation();
  //       }
  //     }
  //     else if (rowData?.min_time == "user") {
  //       const payload = {
  //         userId: rowData?.request_id,
  //         status: "3",
  //         id: rowData?.id
  //       }
  //       // console.log(payload,"asdhasodhoudgodeg")
  //       // return;
  //       const result = await window.Platform.database.releaseUserLocation(payload);

  //       if (result?.status) {
  //         window.NotificationUtils.showError(result?.message || "Release failed!");
  //       } else {
  //         window.NotificationUtils.showSuccess(result?.message || "Released successfully!");
  //         fetchLocation();
  //       }
  //     }
  //     else if (rowData?.min_time == "userA") {
  //       const payload = {
  //         userId: rowData?.request_id,
  //         status: "3",
  //         id: rowData?.id
  //       }
  //       // console.log(payload,"asdhasodhoudgodeg")
  //       // return;
  //       const result = await window.Platform.database.releaseUserLocation(payload);

  //       if (result?.status) {
  //         window.NotificationUtils.showError(result?.message || "Release failed!");
  //       } else {
  //         window.NotificationUtils.showSuccess(result?.message || "Released successfully!");
  //         fetchLocation();
  //       }
  //     }

  //   } catch (error) {
  //     window.NotificationUtils.showError("Error releasing party location!");
  //   } finally {
  //     setLoading(false);
  //   }
  // }; 

  console.log(minTimeValue, "minTimeValue")

  const handleView = async (row) => {
    console.log(row, "rowrowrowrowrowrow")
    setMinTimeValue(row?.min_time);
    setLoading(true);
    if (row?.min_time === "party") {
      setNameForHead("party")
      setRowDataOfModal(row);
      setOpenPartyModal(true);
      setLoading(false);
    }
    if (row?.min_time === "partyB") {
      console.log(row, "PartyB")
      try {
        if (row?.schoolId) {
          const response = await window.Platform.database.getSchoolDataBasedOnId({ schoolId: row?.schoolId })
          if (response.status == false) {
            setSchoolDataBasedOnId(response?.data);
          }
        }
        else {
          const response = await window.Platform.database.getDistributorByID({ id: row?.distributorID })
          if (response.status == false) {
            setSchoolDataBasedOnId(response?.data);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setSchoolDataBasedOnId([]);
      }
      setRowDataOfModal(row);
      setOpenPartyBModal(true);
      setLoading(false);
    }

    else if (row?.min_time === "user" || row?.min_time == "userA") {
      setRowDataOfModal(row);
      setLoading(false);
      setOpenUserModal(true);
    }

    else if (row?.min_time === "visit") {
      const data = await getVisit(row);
    }
    // Bass
    else if (row?.min_time === "partyA") {
      setNameForHead("partyA")
      if (row?.partyData?.schoolId) {
        const data = await getSchoolById(row);
      }
      else if (row?.partyData?.distributorID) {
        const data = await getDistributorById(row);
      }
    }

  };

  const getUsersWeb = async (rowData) => {

  }

  // const getParty = async (data) => {
  //   console.log("party Api", data);
  //    setPartyViewData(data);
  //     setLoading(false);
  //     setOpenPartyModal(true);
  // }
  const getSchoolById = async (rowData) => {
    setRowDataOfModal(rowData);
    let results = await window.Platform.database.getSchoolById({ id: rowData?.school_Id || rowData?.partyData?.schoolId });
    setPartyViewData(results?.data[0]);
    setLoading(false);
    setOpenPartyAdditionModal(true);
  }

  const getDistributorById = async (rowData) => {
    setRowDataOfModal(rowData);
    let results = await window.Platform.database.getDistributorByID({ id: rowData?.distributor_ID || rowData?.partyData?.distributorID });
    setPartyViewData(results?.data[0]);
    setLoading(false);
    setOpenPartyAdditionModal(true);
  }

  const getVisit = async (data) => {
    setRowDataOfModal(data);
    let results = await window.Platform.database.fetchVisitById({ visitId: data?.request_id });
    setVisitViewData(results?.data);
    setLoading(false);
    setOpenVisitModal(true);
  }

  const getPartyAddition = async (data) => {
    console.log("party Addition wali api chli", data);
  }

  // Utility to check if party type is distributor
  function isDistributor(partyType) {
    return partyType && (partyType.toLowerCase() === 'distributor');
  }


  const handleCloseLocationViewModal = () => {
    setOpenLocationViewModal(false);
    setLocationModalData({})
  };


  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees()
    if (results?.status) {
      window.NotificationUtils.showError(results.message);
      setLoading(false);
      return;
    }
    else {
      setAllUsers(results?.data)
      setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
      setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
      setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
      setLoading(false);
    }
  }

  async function getUsers(role, id) {
    setLoading(true);
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setAsms(results?.data)
        setRms(results?.data1)
      }
      if (role == 'asm') {
        setRms(results?.data)
      }
      setLoading(false);
    } else {
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
      }
      if (role == 'asm') {
        setRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
      }
      setLoading(false);
    }
  }

  const getEmployeeColumns = () => {
    const showPartyColumns = Array.isArray(accessChanges) && accessChanges.some(row => row.min_time !== "user" && row.min_time !== "userA");
    const stringOperators = getGridStringOperators().filter((op => ['contains'].includes(op.value)));
    let result = [

      {
        field: "employeeId",
        headerName: "Emp ID",
        sortable: false,
        width: 80,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.employeeId || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "ownerName",
        headerName: "Name",
        sortable: false,
        width: 150,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.ownerName || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "reporting_manager_name",
        headerName: "Reporting Manager",
        sortable: false,
        width: 160,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.reporting_manager_name || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Area",
        headerName: "Area Name",
        sortable: false,
        width: 130,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row.clusterName || "N/A"

          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "createdAt",
        headerName: "Request Date",
        sortable: false,
        width: 180,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let dateStr = params.row.createdAt;
          let name = "N/A";
          if (dateStr) {
            const dateObj = new Date(dateStr);
            name = dateObj.toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
            });
          }
          return (
            <Tooltip title={name}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                {name}
              </Typography>
            </Tooltip>
          );
        },
      },
      showPartyColumns && {
        field: "PartyID",
        headerName: "Party ID",
        sortable: false,
        width: 100,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.SchoolID1 || params.row.distributorID || params.row?.schoolId || params.row?.schoolIdForLocation || params.row?.distributorIDForLocation || "N/A"

          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      showPartyColumns && {
        field: "PartyName",
        headerName: "Party Name",
        sortable: false,
        width: 180,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row.partyData?.distributorName || params.row.partyData?.schoolName || params.row?.DistributorNameForLocation || params.row?.schoolNameForLocation || params?.row?.SchoolNameHO || params?.row?.DistributorNameHO || "N/A"

          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },

      showPartyColumns && {
        field: "partyAddress",
        headerName: "Party Address",
        sortable: false,
        width: 180,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.distributorAddress || params.row?.schoolAddress || params.row.schoolAddressLocation || params.row.distributorAddressLocation || params?.row?.schoolAddressHO || params?.row?.distributorAddressHO || "N/A"

          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "View",
        headerName: "View",
        sortable: false,
        width: 100,
        filterOperators: stringOperators,
        editable: false,
        renderCell: (params) => {
          // let name = params.row?.ownerName || "N/A"
          return (
            <Button variant="contained" size="small" onClick={() => handleView(params.row)} >
              View
            </Button>
          )
        },
      },
     accessModulesData && accessModulesData[0]?.is_approve?.toLowerCase() != "no"&& newOrderStatus !== 3 && {
        field: "Actions",
        headerName: "Actions",
        sortable: false,
        hide: true,
        minWidth: 150,
        filterable: false,
        disableExport: true,
        renderCell: (params) => {
          const isDisabled = params.row?.status === 1 || params.row?.status === 2;
          const showRelease = ["userA", "user", "party"].includes(params.row?.min_time);

          return (
            <>
              {mainFilter !== 29 ? <>
                <Tooltip title="Click to approve"><IconButton disabled={isDisabled} variant="extended" sx={{ color: "#008000" }} onClick={(e) => {
                  e.stopPropagation();
                  approveRejectOrder({ data: params.row, status: "1" });
                }} >
                  <ThumbUpIcon />
                </IconButton></Tooltip>
                <Tooltip title="Click to reject"><IconButton disabled={isDisabled} variant="extended" sx={{ color: "red" }}
                  onClick={(e) => { e.stopPropagation(); handleReject({ status: "2", data: params.row }); }}>
                  <ThumbDownIcon />
                </IconButton></Tooltip>
                {isDisabled && showRelease && (
                  <Tooltip title="Release">
                    <Button
                      variant="contained"
                      color="info"
                      size="small"
                      // sx={{ ml: 1 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        // handleReleasePartyLocation(params.row);
                        setOpenReleaseDialog(true);
                        setRowDataForRelease(params.row);
                      }}
                    >
                      Release
                    </Button>
                  </Tooltip>
                )}
              </>

                :
                <>
                  <Tooltip title="Click to view party in route-plan"><IconButton variant="extended" color="primary" disabled={newOrderStatus !== 0}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleReject({ status: "2", data: params.row });
                    }}
                  >
                    <RemoveRedEyeIcon />
                  </IconButton></Tooltip>
                </>}
            </>
          );
        },
      },
    ].filter(Boolean);;
    return result
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer className="">
        <Button
          onClick={() => { setNewOrderStatus(""); setHasSearched(true) }}
          style={{ backgroundColor: newOrderStatus === "" ? "#8787f470" : "white", color: newOrderStatus === "" ? "#000000" : "black", fontWeight: "500", }}>
          All
        </Button>
        <Button
          onClick={() => { setNewOrderStatus(0); setHasSearched(true) }}
          style={{ backgroundColor: newOrderStatus === 0 ? "#fe9f13" : "white", color: newOrderStatus === 0 ? "white" : "black", fontWeight: "500", }}>
          Pending
        </Button>
        <Button
          onClick={() => { setNewOrderStatus(1); setHasSearched(true) }}
          style={{ backgroundColor: newOrderStatus === 1 ? "green" : "white", color: newOrderStatus === 1 ? "white" : "black", fontWeight: "500", }}>
          Approved
        </Button>
        <Button
          onClick={() => { setNewOrderStatus(2); setHasSearched(true) }}
          style={{ backgroundColor: newOrderStatus === 2 ? "red" : "white", color: newOrderStatus === 2 ? "white" : "black", fontWeight: "500", }}>
          Rejected
        </Button>
        {mainFilter != 38 && <Button
          onClick={() => { setNewOrderStatus(3); setHasSearched(true) }}
          style={{ backgroundColor: newOrderStatus === 3 ? "#409df5" : "white", color: newOrderStatus === 3 ? "white" : "black", fontWeight: "500", }}
        >
          Released
        </Button>}
        <Typography variant="body1" className="ml-4" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
        <Select
          value={paginationModel.pageSize}
          variant="outlined"
          size="small"
          onChange={(e) => { setHasSearched(true); setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
          sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}
        >
          {[10, 20, 30, 50, 100].map((role) => (
            <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role}</MenuItem>
          ))}
        </Select>
      </GridToolbarContainer>
    );
  }

  const renderContent = () => {
    return (
      <DataGridContainer style={{ height: !accessChanges?.length ? '200px' : 'auto' }}>
        <DataGrid
          className="payrollGrid"
          density="compact"
          rows={accessChanges || []}
          columns={getEmployeeColumns()}
          sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
          disableSelectionOnClick
          disableRowSelectionOnClick
          rowHeight={60}
          disableDensitySelector
          pageSizeOptions={[10]}
          onFilterModelChange={(val) => {
            if (val?.items[0]?.value?.length > 0) {
            } else if (!val.items[0]?.value) {
              console.log("CHECKING...1")
            }
            else {
              fetchLocation()
              setFilter(false)
            }
          }
          }
          filterMode="server"
          apiRef={apiRef}
          rowCount={rowCount}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          components={{
            Toolbar: CustomToolbar,
          }}
        />
      </DataGridContainer>
    );
  };

  return (
    <>
      <StaffEditorPageContainer>
        {loading && <OpaqueLoading />}
        <HeaderContainer>
          <Paper elevation={3}
            sx={{
              p: 2,
              mb: 3,
              width: '100%',        // takes full width of parent
              // maxWidth: '1000px',   // optional: control max width
              mx: 'auto',
              backgroundColor: "#ebf0fa"          // center it horizontally
            }}>
            <div className="container-fluid" style={{ width: "100%" }}>
              <div className="row mb-2">
                {userData?.role.includes('admin') && (
                  <div className="col-md-3 mt-1">
                    <Autocomplete
                      options={rsms}
                      // getOptionLabel={(option) => option.name || ""}
                      getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                      value={rsms.find((role) => role.id === rsm) || null}
                      // onChange={(event, value) => {
                      //   setRsm(value ? value.id : "");
                      //   getUsers('rsm', value ? value.id : "");
                      // }}
                      onChange={(event, value) => {
                        setRsm(value ? value.id : "");
                        setAsm("");
                        setRm("");
                        getUsers('rsm', value ? value.id : "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          label="Select HO"
                          {...params}
                          variant="outlined"
                          size="small"
                          placeholder="Select HO"
                          sx={{
                            '& .MuiInputBase-input': {
                              fontWeight: 500,
                              color: 'black',
                            },
                          }}
                          InputLabelProps={{
                            style: { color: "black" }, // Label color
                          }}
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      sx={{
                        width: '100%',
                        fontSize: 14,
                        '& .MuiAutocomplete-input': {
                          fontWeight: 500,
                          color: 'black',
                        },
                        '& .MuiAutocomplete-option': {
                          fontWeight: 500,
                          color: 'black',
                        },
                      }}
                    />
                  </div>
                )}
                {userData?.role !== 'asm' && (
                  <div className="col-md-3 mt-1">
                    <Autocomplete
                      options={asms}
                      // getOptionLabel={(option) => option.name || ""}
                      getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                      value={asms.find((role) => role.id === asm) || null}
                      // onChange={(event, value) => {
                      //   setAsm(value ? value.id : "");
                      //   getUsers('asm', value ? value.id : "");
                      // }}
                      onChange={(event, value) => {
                        setAsm(value ? value.id : "");
                        setRm(""); // Reset RM
                        getUsers('asm', value ? value.id : "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          label="Select ARM"
                          {...params}
                          // variant="outlined"
                          size="small"
                          placeholder="Select ARM"
                          sx={{
                            '& .MuiInputBase-input': {
                              fontWeight: 500,
                              color: 'black',
                            },
                          }}
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      sx={{
                        width: '100%',
                        fontSize: 14,
                        '& .MuiAutocomplete-input': {
                          fontWeight: 500,
                          color: 'black',
                        },
                        '& .MuiAutocomplete-option': {
                          fontWeight: 500,
                          color: 'black',
                        },
                      }}
                    />
                  </div>
                )}
                <div className="col-md-3 mt-1">
                  <Autocomplete
                    options={rms}
                    // getOptionLabel={(option) => option.name || ""}
                    getOptionLabel={(option) => option.name && option.username ? `${option.name} - ${option.username}` : option.name || option.username || ""}
                    value={rms.find((role) => role.id === rm) || null}
                    onChange={(event, value) => {
                      setRm(value ? value.id : "");
                      // getUsers('rm', value ? value.id : "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        label="Select RM"
                        {...params}
                        // variant="outlined"
                        size="small"
                        placeholder="Select RM"
                        sx={{
                          '& .MuiInputBase-input': {
                            fontWeight: 500,
                            color: 'black',
                          },
                        }}
                      />
                    )}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    sx={{
                      width: '100%',
                      fontSize: 14,
                      '& .MuiAutocomplete-input': {
                        fontWeight: 500,
                        color: 'black',
                      },
                      '& .MuiAutocomplete-option': {
                        fontWeight: 500,
                        color: 'black',
                      },
                    }}
                  />
                </div>
                <div className="col-md-3 mt-1">
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Request</InputLabel>
                    <Select
                      value={mainFilter}
                      label="Select Request"
                      onChange={(e) => setMainFilter(e.target.value)}
                      sx={{
                        fontWeight: 700,
                        color: '#111',
                        '& .MuiSelect-select': {
                          fontWeight: 500,
                          color: 'black',
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            '& .MuiMenuItem-root': {
                              fontWeight: 500,
                              color: 'black',
                            },
                          },
                        },
                      }}
                    >
                      <MenuItem value="" sx={{ fontWeight: 500, color: 'black' }}>All</MenuItem>
                      {mainFilterList && mainFilterList?.map((ele, ind) => {
                        return <MenuItem key={ind} value={ele?.id} sx={{ fontWeight: 500, color: 'black' }}>{ele?.name}</MenuItem>
                      })}
                      {/* <MenuItem value="28">Party Location</MenuItem>
                    <MenuItem value="27">Self Location</MenuItem>
                    <MenuItem value="29">HO Actionable Items</MenuItem>
                    <MenuItem value="30">Party Addition</MenuItem> */}
                    </Select>
                  </FormControl>
                </div>
                {/* {mainFilter === "28" && <div className="col-md-3 mt-3">
                <FormControl style={{ width: isMobile ? "100%" : "100%" }} sx={{ fontSize: 14 }}>
                  <InputLabel >Select Party</InputLabel>
                  <Select
                    labelId={`Party`}
                    label="Select Party"
                    value={partyType}
                    onChange={(e) => setPartyType(e.target.value)}
                    size="small"
                  >
                    <MenuItem value="" hidden>
                      Select Party
                    </MenuItem>
                    <MenuItem value="all">
                      All
                    </MenuItem>
                    <MenuItem value="school">
                      School
                    </MenuItem>
                    <MenuItem value="distributor">
                      Distributor
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>} */}
              </div>
              <div className="row mt-3 mb-2">
                <div className='col-md-4'>
                  <FormControl size="small" fullWidth>
                    <TextField
                      label="Search By Party ID or Party Name"
                      size="small"
                      value={search}
                      placeholder="Search By Party ID or Party Name"
                      className="form-control"
                      onChange={(e) => setSearch(e.target.value)}
                      sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
                      InputLabelProps={{
                        shrink: true,
                        style: { color: "black", fontSize: "14px", fontWeight: 500 }
                      }}
                      inputProps={{
                        style: { color: "black", fontSize: "14px", fontWeight: 500 }
                      }}
                    />
                  </FormControl>
                </div>
                <div className='col-md-2'>
                  <Button variant="contained" size="small" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} color="primary" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => { setHasSearched(true); fetchLocation(); }}>
                    Find
                  </Button>
                </div>
                <div className="col-md-3 mt-1">
                  <Button variant="contained" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} color="secondary" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => clearFilters()}>
                    Clear Filters
                  </Button>
                </div>
               {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no"&& <div className='col-md-3 mt-1'>
                  <Button variant="contained" size="small" startIcon={<FileDownloadIcon />} color="success" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => downloadUserRequestExcel()} >
                    Download
                  </Button>
                </div>}
              </div>
            </div>
          </Paper>
        </HeaderContainer>
        {/* <TableContainer>{renderContent()}</TableContainer> */}
        <TableContainer>
          {renderContent()}
        </TableContainer>
      </StaffEditorPageContainer>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>HO Actionable Items</DialogTitle>
        <DialogContent>
          <TextField autoFocus margin="dense" label="Remark" type="text" fullWidth variant="outlined" value={reason} onChange={(e) => setReason(e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmReject} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {/* Party Detail modal */}

      <Dialog open={openPartyModal} onClose={() => setOpenPartyModal(false)} maxWidth="lg" fullWidth sx={{ m: 0, p: 0 }}>
        <DialogTitle>
          <div className="row">
            <div className="col-md-5">
              <Typography>
                <b>Party Location</b>
              </Typography>
            </div>
            <div className="col-md-4 mb-2">
              <Typography>
                <b>Lattitude : </b>
                {(() => {
                  // Try schoolLocationLat, then distributorLocationLat, then fallback to data.lat
                  if (rowDataOfModal?.schoolLocationLat) return rowDataOfModal.schoolLocationLat;
                  if (rowDataOfModal?.distributorLocationLat) return rowDataOfModal.distributorLocationLat;
                  let data = rowDataOfModal?.data;
                  if (typeof data === 'string') {
                    try { data = JSON.parse(data); } catch (e) { data = {}; }
                  }
                  return data?.lat || 'N/A';
                })()}
              </Typography>
            </div>
            <div className="col-md-3 mb-2">
              <Typography>
                <b>Longitude : </b>
                {(() => {
                  // Try schoolLocationLong, then distributorLocationLong, then fallback to data.long
                  if (rowDataOfModal?.schoolLocationLong) return rowDataOfModal.schoolLocationLong;
                  if (rowDataOfModal?.distributorLocationLong) return rowDataOfModal.distributorLocationLong;
                  let data = rowDataOfModal?.data;
                  if (typeof data === 'string') {
                    try { data = JSON.parse(data); } catch (e) { data = {}; }
                  }
                  return data?.long || 'N/A';
                })()}
              </Typography>
            </div>
          </div>
        </DialogTitle>
        <DialogContent
          sx={{
            height: '600px',
            maxHeight: '600px',
            overflow: 'hidden',
            p: 0
          }}
        >
          {(() => {
            // Try school/distributor lat/long, else fallback to data.lat/long
            let lat = rowDataOfModal?.schoolLocationLat || rowDataOfModal?.distributorLocationLat;
            let lng = rowDataOfModal?.schoolLocationLong || rowDataOfModal?.distributorLocationLong;
            if (!lat || !lng) {
              let data = rowDataOfModal?.data;
              if (typeof data === 'string') {
                try { data = JSON.parse(data); } catch (e) { data = {}; }
              }
              lat = data?.lat;
              lng = data?.long;
            }
            if (lat && lng) {
              return (
                <Box sx={{ height: '100%' }}>
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={{ lat: Number(lat), lng: Number(lng) }}
                    zoom={14}
                    options={{
                      disableDefaultUI: false,
                      zoomControl: true,
                      streetViewControl: false,
                    }}
                  >
                    <Marker
                      position={{ lat: Number(lat), lng: Number(lng) }}
                      onMouseOver={() => {
                        const nlat = Number(lat);
                        const nlng = Number(lng);
                        if (!hoveredAuditor || hoveredAuditor.lat !== nlat || hoveredAuditor.lng !== nlng) {
                          setHoveredAuditor({
                            lat: nlat,
                            lng: nlng,
                            label: "User Location"
                          });
                        }
                      }}
                      onClick={() => {
                        const nlat = Number(lat);
                        const nlng = Number(lng);
                        if (!hoveredAuditor || hoveredAuditor.lat !== nlat || hoveredAuditor.lng !== nlng) {
                          setHoveredAuditor({
                            lat: nlat,
                            lng: nlng,
                            label: "User Location"
                          });
                        }
                      }}
                      onMouseOut={() => {
                        setTimeout(() => {
                          if (!infoWindowHovered) setHoveredAuditor(null);
                        }, 20000);
                      }}
                    />
                    {hoveredAuditor && (
                      <InfoWindow
                        position={{ lat: hoveredAuditor.lat, lng: hoveredAuditor.lng }}
                        onCloseClick={() => setHoveredAuditor(null)}
                      >
                        <div
                          onMouseEnter={() => setInfoWindowHovered(true)}
                          onMouseLeave={() => {
                            setInfoWindowHovered(false);
                            setTimeout(() => {
                              if (!infoWindowHovered) setHoveredAuditor(null);
                            }, 200);
                          }}
                          style={{
                            height: "230px",
                            width: "500px"
                          }}
                        >
                          <div>
                            <b style={{ fontSize: "12px" }}>Added By RM:</b>
                            <span style={{ marginLeft: "4px", fontWeight: "400", color: "black", fontSize: "11px" }}>
                              {rowDataOfModal?.createdByRM == "rm" ? "Yes" : "No"}
                            </span>
                          </div>
                          <div className='mt-1'>
                            <b style={{ fontSize: "12px" }}>RM Name:</b>
                            <span style={{ fontWeight: "400", color: "black", fontSize: "11px" }}>
                              {rowDataOfModal?.ownerName}
                            </span>
                          </div>
                          <div className='mt-1'>
                            <b style={{ fontSize: "12px" }}>reporting Manager Name:</b>
                            <span style={{ marginLeft: "4px", fontWeight: "400", color: "black", fontSize: "11px" }}>
                              {rowDataOfModal?.reporting_manager_name}
                            </span>
                          </div>
                          <div className='mt-1'>
                            <b style={{ fontSize: "12px" }}>Area Name:</b>
                            <span style={{ marginLeft: "4px", fontWeight: "400", color: "black", fontSize: "11px" }}>
                              {rowDataOfModal?.clusterName}
                            </span>
                          </div>
                          <div className='mt-1'>
                            <b style={{ fontSize: "12px" }}>Party ID:</b>
                            <span style={{ marginLeft: "4px", fontWeight: "400", color: "black", fontSize: "11px" }}>
                              {rowDataOfModal?.schoolIdForLocation || rowDataOfModal?.distributorIDForLocation}
                            </span>
                          </div>
                          <div className='mt-1'>
                            <b style={{ fontSize: "12px" }}>Name:</b>
                            <span style={{ marginLeft: "4px", fontWeight: "400", color: "black", fontSize: "11px" }}>
                              {rowDataOfModal?.schoolNameForLocation || rowDataOfModal?.DistributorNameForLocation}
                            </span>
                          </div>
                          <div className='mt-1'>
                            <b style={{ fontSize: "12px" }}>Address:</b>
                            <span style={{ marginLeft: "4px", fontWeight: "400", color: "black", fontSize: "11px" }}>
                              {rowDataOfModal?.schoolAddressLocation || rowDataOfModal?.distributorAddressLocation}
                            </span>
                          </div>
                          <div className='mt-1'>
                            <b style={{ fontSize: "12px" }}>Latitude:</b>
                            <span style={{ marginLeft: "4px", fontWeight: "400", color: "black", fontSize: "11px" }}>
                              {hoveredAuditor.lat}
                            </span>
                          </div>
                          <div className='mt-1'>
                            <b style={{ fontSize: "12px" }}>Longitude:</b>
                            <span style={{ marginLeft: "4px", fontWeight: "400", color: "black", fontSize: "11px" }}>
                              {hoveredAuditor.lng}
                            </span>
                          </div>
                          <div className='mt-1'>
                            <b style={{ fontSize: "12px" }}>Tagged Address:</b>
                            <span style={{ marginLeft: "4px", fontWeight: "400", color: "black", fontSize: "11px" }}>
                              {rowDataOfModal?.schLatlong_address || rowDataOfModal?.distLatlong_address || "N/A"}
                            </span>
                          </div>
                          <Button onClick={() => setHoveredAuditor(null)} color='primary' variant='contained' sx={{ p: 0, m: 0, float: "right", mt: 1 }}> Close </Button>
                        </div>
                      </InfoWindow>
                    )}
                  </GoogleMap>
                </Box>
              );
            } else {
              return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <h3>Address Not Found</h3>
                </div>
              );
            }
          })()}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPartyModal(false)} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Party Additional Modal */}

      <Dialog open={openPartyAdditionModal} onClose={() => setOpenPartyAdditionModal(false)} maxWidth="lg" fullWidth>
        <DialogTitle>
          {nameForHead == "party" ? "Party Details" : nameForHead == "partyA" ? "Party Additional Details" : ""}
        </DialogTitle>
        <DialogContent>
          {partyViewData?.schoolId && (
            <Box>

              <div className="row">
                <div className="col-md-6">
                  <Typography><b>Party Id:</b> {partyViewData.schoolId || "N/A"}</Typography>
                </div>
                <div className="col-md-6">
                  <Typography><b>Party Name:</b> {partyViewData.schoolName || "N/A"}</Typography>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <Typography><b>Parent School Name:</b> {partyViewData.parentSchoolName || "N/A"}</Typography>
                </div>
                <div className="col-md-6">
                  <Typography><b>Email:</b> {partyViewData.email || "N/A"}</Typography>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <Typography><b>Medium Name:</b> {partyViewData.mediumName || "N/A"}</Typography>
                </div>
                <div className="col-md-6">
                  <Typography><b>Board Name:</b> {partyViewData.boardName || "N/A"}</Typography>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <Typography><b>Grade:</b> {partyViewData.gradeName || "N/A"}</Typography>
                </div>
                <div className="col-md-6">
                  <Typography><b>Strength:</b> {partyViewData.strength || "N/A"}</Typography>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <Typography><b>Decision Maker Name:</b> {partyViewData.makerName || "N/A"}</Typography>
                </div>
                <div className="col-md-6">
                  <Typography><b>Decision Maker Number:</b> {partyViewData.makerContact || "N/A"}</Typography>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <Typography><b>Address:</b> {partyViewData.AddressLine1 || "N/A"}</Typography>
                </div>
                <div className="col-md-6">
                  <Typography><b>District:</b> {partyViewData.District || "N/A"}</Typography>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <Typography><b>State:</b> {partyViewData.State || "N/A"}</Typography>
                </div>
                <div className="col-md-6">
                  <Typography><b>Pincode:</b> {partyViewData.Pincode || "N/A"}</Typography>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <Typography><b>Status:</b> {rowDataOfModal?.status == "1" ? "Approved" : rowDataOfModal?.status == "2" ? "Rejected" : "Pending" || "N/A"}</Typography>
                </div>
                <div className="col-md-6">
                  {rowDataOfModal?.status == "2" && <Typography><b>Rejected Remark:</b> {rowDataOfModal?.remark || "N/A"}</Typography>}
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <Typography><b>Added By:</b> {partyViewData.name || "N/A"}</Typography>
                </div>
                <div className="col-md-6">
                  {/* {rowDataOfModal?.status == "2" && <Typography><b>Rejected Remark:</b> {rowDataOfModal?.remark || "N/A"}</Typography>} */}
                </div>
              </div>
            </Box>
          )}

          {partyViewData?.distributorID && (
            <Box>
              <div className="row">
                <div className="col-md-6">
                  <Typography><b>Party Id:</b> {partyViewData?.distributorID || "N/A"}</Typography>
                </div>
                <div className="col-md-6">
                  <Typography><b>Party Name:</b> {partyViewData?.DistributorName || "N/A"}</Typography>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <Typography><b>Area Name:</b> {partyViewData?.cluster_name || "N/A"}</Typography>
                </div>
                <div className="col-md-6">
                  <Typography><b>Email:</b> {partyViewData?.email || "N/A"}</Typography>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <Typography><b>Decision Maker Name:</b> {partyViewData?.makerName || "N/A"}</Typography>
                </div>
                <div className="col-md-6">
                  <Typography><b>Decision Maker Number:</b> {partyViewData?.makerContact || "N/A"}</Typography>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <Typography><b>Distributor Name:</b> {partyViewData?.DistributorName || "N/A"}</Typography>
                </div>
                <div className="col-md-6">
                  <Typography><b>Address:</b> {partyViewData?.AddressLine1 || "N/A"}</Typography>
                </div>
              </div>
              {/* <div className="row mt-2">
                <div className="col-md-6">
                  <Typography><b>Distributor Lattitude : </b> {rowDataOfModal?.distributorLat}</Typography>
                </div>
                <div className="col-md-6">
                  <Typography><b>Distributor Longitude : </b> {rowDataOfModal?.distributorLong}</Typography>
                </div>
              </div> */}
              <div className="row mt-2">
                <div className="col-md-6">
                  <Typography><b>District:</b> {partyViewData?.District || "N/A"}</Typography>
                </div>
                <div className="col-md-6">
                  <Typography><b>State:</b> {partyViewData?.State || "N/A"}</Typography>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <Typography><b>Pincode:</b> {partyViewData?.Pincode || "N/A"}</Typography>
                </div>
                <div className="col-md-6">
                  <Typography><b>Status:</b> {rowDataOfModal?.status == "1" ? "Approved" : rowDataOfModal?.status == "2" ? "Rejected" : "Pending" || "N/A"}</Typography>
                </div>
              </div>
              <div className="row mt-2">
                {rowDataOfModal?.status == "2" && <div className="col-md-6">
                  <Typography><b>Rejected Remark:</b> {rowDataOfModal?.remark || "N/A"}</Typography>
                </div>}
                <div className="col-md-6">
                  <Typography><b>Added By:</b> {partyViewData?.name || "N/A"}</Typography>
                </div>
              </div>
            </Box>
          )}
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={() => setOpenPartyModal(false)} variant="contained">Close</Button>
        </DialogActions> */}

        <DialogActions>
          <Button variant="contained" color="success"
            disabled={rowDataOfModal?.status === 1 || rowDataOfModal?.status === 2}
            onClick={() => {
              approveRejectOrder({ data: rowDataOfModal, status: "1" });
            }}
          >
            Approve
          </Button>
          <Button variant="contained" color="error"
            disabled={rowDataOfModal?.status === 1 || rowDataOfModal?.status === 2}
            onClick={() => {
              handleReject({ data: rowDataOfModal, status: "2" });
            }}
          >
            Reject
          </Button>
          <Button onClick={() => setOpenPartyAdditionModal(false)} variant="contained" color="secondary">
            Close
          </Button>
        </DialogActions>

      </Dialog>


      {/* User Details Modal */}

      <Dialog open={openUserModal} onClose={() => setOpenUserModal(false)} maxWidth="lg" fullWidth>
        <DialogTitle>
          <div className="row">
            <div className="col-md-6">
              <Typography>
                <b> User Details </b>
              </Typography>
            </div>
            <div className="col-md-3 mb-2">
              <Typography>
                <b>Lattitude : </b>
                {rowDataOfModal?.selfLatitude || rowDataOfModal && rowDataOfModal?.data && JSON.parse(rowDataOfModal?.data)?.lat|| 'N/A'}
              </Typography>
            </div>
            <div className="col-md-3 mb-2">
              <Typography>
                <b>Longitude : </b>
                {rowDataOfModal?.selfLongitude  || rowDataOfModal && rowDataOfModal?.data && JSON.parse(rowDataOfModal?.data)?.long || "N/A"}
              </Typography>
            </div>
          </div>
        </DialogTitle>
        <DialogContent
          sx={{ height: '600px', maxHeight: '600px', overflow: 'hidden', p: 0 }}
        >
          {((rowDataOfModal?.selfLatitude && rowDataOfModal?.selfLongitude) || (rowDataOfModal && rowDataOfModal?.data && JSON.parse(rowDataOfModal?.data)?.lat && rowDataOfModal && rowDataOfModal?.data && JSON.parse(rowDataOfModal?.data)?.long)) ? (
            <Box sx={{ height: '100%' }}>
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={{
                  lat: Number(rowDataOfModal.selfLatitude || rowDataOfModal && rowDataOfModal?.data && JSON.parse(rowDataOfModal?.data)?.lat),
                  lng: Number(rowDataOfModal.selfLongitude || rowDataOfModal && rowDataOfModal?.data && JSON.parse(rowDataOfModal?.data)?.long)
                }}
                zoom={14}
                options={{
                  disableDefaultUI: false,
                  zoomControl: true,
                  streetViewControl: false,
                }}
              >
                <Marker
                  position={{
                    lat: Number(rowDataOfModal.selfLatitude || rowDataOfModal && rowDataOfModal?.data && JSON.parse(rowDataOfModal?.data)?.lat),
                    lng: Number(rowDataOfModal.selfLongitude || rowDataOfModal && rowDataOfModal?.data && JSON.parse(rowDataOfModal?.data)?.long)
                  }}
                  onMouseOver={() => {
                    const lat = Number(rowDataOfModal.selfLatitude || rowDataOfModal && rowDataOfModal?.data && JSON.parse(rowDataOfModal?.data)?.lat);
                    const lng = Number(rowDataOfModal.selfLongitude || rowDataOfModal && rowDataOfModal?.data && JSON.parse(rowDataOfModal?.data)?.long);
                    if (!hoveredAuditor || hoveredAuditor.lat !== lat || hoveredAuditor.lng !== lng) {
                      setHoveredAuditor({
                        lat,
                        lng,
                        label: "User Location"
                      });
                    }
                  }}
                  onClick={() => {
                    const lat = Number(rowDataOfModal.selfLatitude || rowDataOfModal && rowDataOfModal?.data && JSON.parse(rowDataOfModal?.data)?.lat);
                    const lng = Number(rowDataOfModal.selfLongitude || rowDataOfModal && rowDataOfModal?.data && JSON.parse(rowDataOfModal?.data)?.long);
                    if (!hoveredAuditor || hoveredAuditor.lat !== lat || hoveredAuditor.lng !== lng) {
                      setHoveredAuditor({
                        lat,
                        lng,
                        label: "User Location"
                      });
                    }
                  }}
                  onMouseOut={() => {
                    setTimeout(() => {
                      if (!infoWindowHovered) setHoveredAuditor(null);
                    }, 20000);
                  }}
                />
                {hoveredAuditor && (
                  <InfoWindow
                    position={{ lat: hoveredAuditor.lat, lng: hoveredAuditor.lng }}
                    onCloseClick={() => setHoveredAuditor(null)}
                  >
                    <div
                      onMouseEnter={() => setInfoWindowHovered(true)}
                      onMouseLeave={() => {
                        setInfoWindowHovered(false);
                        setTimeout(() => {
                          if (!infoWindowHovered) setHoveredAuditor(null);
                        }, 200);
                      }}
                      style={{
                        height: "150px",
                        width: (
                          (rowDataOfModal?.schoolAddress && rowDataOfModal.schoolAddress.length > 40)) ? "500px" : "450px"
                      }}
                    >
                      <div>
                        <b style={{ fontSize: "12px" }}>RM Name:</b>
                        <span style={{ marginLeft: "4px", fontWeight: "400", color: "black", fontSize: "11px" }}>
                          {rowDataOfModal?.ownerName || "N/A"}
                        </span>
                      </div>
                      <div className='mt-1'>
                        <b style={{ fontSize: "12px" }}>reporting Manager Name:</b>
                        <span style={{ marginLeft: "4px", fontWeight: "400", color: "black", fontSize: "11px" }}>
                          {rowDataOfModal?.reporting_manager_name || "N/A"}
                        </span>
                      </div>
                      <div className='mt-1'>
                        <b style={{ fontSize: "12px" }}>Area Name:</b>
                        <span style={{ marginLeft: "4px", fontWeight: "400", color: "black", fontSize: "11px" }}>
                          {rowDataOfModal?.clusterName || "N/A"}
                        </span>
                      </div>
                      <div className='mt-1'>
                        <b style={{ fontSize: "12px" }}>Latitude:</b>
                        <span style={{ marginLeft: "4px", fontWeight: "400", color: "black", fontSize: "11px" }}>
                          {hoveredAuditor.lat || "N/A"}
                        </span>
                      </div>
                      <div className='mt-1'>
                        <b style={{ fontSize: "12px" }}>Longitude:</b>
                        <span style={{ marginLeft: "4px", fontWeight: "400", color: "black", fontSize: "11px" }}>
                          {hoveredAuditor.lng  || "N/A"}
                        </span>
                      </div>
                    { rowDataOfModal && rowDataOfModal?.min_time == "user" && <div className='mt-1'>
                        <b style={{ fontSize: "12px" }}>Base Address:</b>
                        <span style={{ marginLeft: "4px", fontWeight: "400", color: "black", fontSize: "11px" }}>
                          {rowDataOfModal && rowDataOfModal?.data && JSON.parse(rowDataOfModal?.data)?.baseAddress || "N/A"}
                        </span>
                      </div>}
                    </div>
                  </InfoWindow>
                )}
              </GoogleMap>
            </Box>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <h3>Address Not Found</h3>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenUserModal(false)} variant="contained">Close</Button>
        </DialogActions>
      </Dialog>

      {/* Visit Details Modal  */}

      <Dialog open={openVisitModal} onClose={() => setOpenVisitModal(false)} maxWidth="lg" fullWidth>
        <DialogTitle sx={{ color: "black", fontWeight: "500", fontSize: "18px" }}>
          HO Actionable Details
        </DialogTitle>
        <DialogContent>
          {visitViewData && (
            <Box>
              <div>
                <div className="row mb-2 mt-1">
                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}> Party Id : </b> <span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} >{visitViewData[0]?.partyId || "N/A"}</span>
                  </div>
                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}> Party Name :</b> <span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} > {visitViewData[0]?.schoolName ? visitViewData[0]?.schoolName : visitViewData[0]?.DistributorName || "N/A" || "N/A"} </span>
                  </div>
                </div>
                <div className="row mt-2 mb-1">
                  <div className="col-md-6">
                    <Typography><b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}>Ho Actionable Items:</b><span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} >   {visitViewData[0]?.ho_need_remark || "N/A"} </span></Typography>
                  </div>
                  <div className="col-md-6">
                    <Typography><b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}>Remark:</b> <span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} >  {rowDataOfModal?.remark || "N/A"} </span> </Typography>
                  </div>
                </div>
                <div className="row mb-1 mt-2">
                  <div className="col-md-6">
                    {/* <b style={{fontSize:"16px", fontWeight:"500", color:"black"}}>Visit Start Time : </b> {visitViewData[0]?.startTime || "N/A"} */}
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}>Visit Start Time : </b>
                    <span style={{ color: "black", fontWeight: "500", fontSize: "13px" }} >  {visitViewData[0]?.startTime
                      ? new Date(visitViewData[0].startTime).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                      : "N/A"} </span>
                  </div>
                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}>Meeting Start Time : </b>
                    {/* {visitViewData[0]?.start_time_meeting || "N/A"} */}
                    <span style={{ color: "black", fontWeight: "500", fontSize: "13px" }} >  {visitViewData[0]?.start_time_meeting
                      ? new Date(visitViewData[0].start_time_meeting).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                      : "N/A"} </span>
                  </div>

                </div>
                <div className="row mb-1 mt-2">

                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}>MeetingEnd Tiime :</b>
                    {/* {visitViewData[0]?.end_time_meeting || "N/A"} */}
                    <span style={{ color: "black", fontWeight: "500", fontSize: "13px" }} >  {visitViewData[0]?.end_time_meeting
                      ? new Date(visitViewData[0].end_time_meeting).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                      : "N/A"}</span>
                  </div>
                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}>Visit End Tiime :</b>
                    {/* {visitViewData[0]?.endTime || "N/A"} */}
                    <span style={{ color: "black", fontWeight: "500", fontSize: "13px" }} >   {visitViewData[0]?.endTime
                      ? new Date(visitViewData[0].endTime).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
                      : "N/A"} </span>
                  </div>
                </div>
                <div className="row mb-1 mt-2">
                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}>Visit Done By : </b> <span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} >  {visitViewData[0]?.u_name || "N/A"}</span>
                  </div>
                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}> Visit Type :</b><span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} >  {visitViewData[0]?.typeName || "N/A"}  </span>
                  </div>
                </div>
                <div className="row mb-1 mt-2">
                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}> Contact Person Name : </b> <span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} > {visitViewData[0]?.ContactPerson || "N/A"}</span>
                  </div>
                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}> Contact Person Number :</b><span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} >  {visitViewData[0]?.PhoneNumber || "N/A"} </span>
                  </div>
                </div>
                <div className="row mb-1 mt-2">
                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}> Visit Status : </b> <span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} > {visitViewData[0]?.statusTypeName || "N/A"} </span>
                  </div>
                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}> Work Done :</b> <span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} > {visitViewData[0]?.workDoneName || "N/A"} </span>
                  </div>
                </div>

                <div className="row mb-1 mt-2">
                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}> Start Visit Address : </b> <span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} > {visitViewData[0]?.start_address || "N/A"} </span>
                  </div>
                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}>  End Visit Address : </b><span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} >  {visitViewData[0]?.end_address || "N/A"}</span>
                  </div>
                </div>
                <div className="row mb-1 mt-2">
                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}> Feedback : </b> <span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} >  {visitViewData[0]?.feedbackName || "N/A"} </span>
                  </div>
                  <div className="col-md-6">
                    {/* <b style={{fontSize:"14px", fontWeight:"600", color:"black"}}> Remark : </b> {visitViewData[0]?.remarks || "N/A"} */}
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}> Visit OutCome : </b><span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} >  {visitViewData[0]?.name || "N/A"} </span>
                  </div>
                </div>
                <div className="row mb-1 mt-2">

                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}> Follow Up Date : </b>
                    {/* {visitViewData[0]?.followUpDate || "N/A"} */}
                    <span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} >    {visitViewData[0]?.followUpDate
                      ? new Date(visitViewData[0].followUpDate).toLocaleDateString('en-GB')
                      : "N/A"} </span>
                  </div>
                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}> Supervisor : </b><span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} >  {visitViewData[0]?.superwisor_name || "N/A"}</span>
                  </div>
                </div>
                <div className="row mb-1 mt-1">
                  <div className="col-md-6">
                    <b style={{ fontSize: "14px", fontWeight: "600", color: "black" }}> Colleague : </b><span style={{ color: "black", fontWeight: "500", fontSize: "14px" }} >  {visitViewData[0]?.tag_user || "N/A"}</span>
                  </div>
                </div>
              </div>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenVisitModal(false)} variant="contained">Close</Button>
        </DialogActions>
      </Dialog>

      {/* Party Update Modal */}
      <Dialog open={openPartyBModal} onClose={() => setOpenPartyBModal(false)} maxWidth="lg" fullWidth>
        <DialogTitle>
          <b>Party Update Details</b>
        </DialogTitle>
        <DialogContent>


          {newOrderStatus == 0 ? <Box>
            {(() => {
              let data = rowDataOfModal?.data;
              if (typeof data === 'string') {
                try { data = JSON.parse(data); } catch (e) { data = {}; }
              }
              if (!data || typeof data !== 'object') return <div>N/A</div>;
              let distributor = data.distributor;
              if (typeof distributor === 'string') {
                try { distributor = JSON.parse(distributor); } catch (e) { distributor = distributor; }
              }
              const safeRender = (value, field) => {
                if (field === 'distributor') {
                  if (value && typeof value === 'object' && 'name' in value) {
                    return value.name || 'N/A';
                  }
                  if (typeof value === 'string') return value || 'N/A';
                  return 'N/A';
                }
                if (value == null) return 'N/A';
                if (typeof value === 'object') {
                  if (Array.isArray(value)) return value.join(', ');
                  if (value.name) return value.name;
                  return JSON.stringify(value);
                }
                return value;
              };
              const getNameById = (list, id, nameKey, idKey) => {
                if (!id || !Array.isArray(list)) return id || 'N/A';
                const found = list.find(item => String(item[idKey]) === String(id));
                return found ? found[nameKey] : id;
              };

              let fields = [
                { label: 'School ID', update: rowDataOfModal?.partyData?.schoolId, prev: schoolDataBasedOnId[0]?.schoolId },
                { label: 'School Name', update: safeRender(data.schoolName), prev: schoolDataBasedOnId[0]?.schoolName },
                { label: 'Email', update: safeRender(data.email), prev: schoolDataBasedOnId[0]?.email },
                { label: 'Board', update: getNameById(dropdownData.board, data.board, 'boardName', 'boardId'), prev: getNameById(dropdownData.board, schoolDataBasedOnId[0]?.boardName, 'boardName', 'boardId') },
                { label: 'Grade', update: getNameById(dropdownData.grade, data.grade, 'gradeName', 'gradeId'), prev: getNameById(dropdownData.grade, schoolDataBasedOnId[0]?.grade_names, 'gradeName', 'gradeId') },
                { label: 'Medium', update: getNameById(dropdownData.medium, data.medium, 'mediumName', 'mediumTableId'), prev: getNameById(dropdownData.medium, schoolDataBasedOnId[0]?.medium, 'mediumName', 'mediumTableId') },
                { label: 'Contact Person Role', update: getNameById(dropdownData.makerRole, data.makerRole, 'roleName', 'contactPersonRoleId'), prev: getNameById(dropdownData.makerRole, schoolDataBasedOnId[0]?.roleName, 'roleName', 'contactPersonRoleId') },
                { label: 'Contact Person Name', update: safeRender(data.makerName), prev: schoolDataBasedOnId[0]?.makerName },
                { label: 'Contact Person Number', update: safeRender(data.makerContact), prev: schoolDataBasedOnId[0]?.makerContact },
                { label: 'Distributor', update: safeRender(distributor, 'distributor'), prev: schoolDataBasedOnId[0]?.DistributorName },
                { label: 'Address Line 1', update: safeRender(data.addressLine1), prev: schoolDataBasedOnId[0]?.AddressLine1 },
                { label: 'Address Line 2', update: safeRender(data.addressLine2), prev: schoolDataBasedOnId[0]?.AddressLine2 },
                { label: 'Pincode', update: safeRender(data.pincode), prev: schoolDataBasedOnId[0]?.Pincode },
              ];
              // Hide Board, Medium, Grade, School ID, School Name for distributor, and show Distributor ID/Name
              if (isDistributor(rowDataOfModal?.partyType)) {
                fields = [
                  { label: 'Distributor ID', update: rowDataOfModal?.partyData?.distributorID, prev: schoolDataBasedOnId[0]?.distributorID },
                  { label: 'Distributor Name', update: safeRender(data.name), prev: schoolDataBasedOnId[0]?.DistributorName },
                  ...fields.filter(f => !['Board', 'Medium', 'Grade', 'School ID', 'School Name', 'Distributor'].includes(f.label))
                ];
              }
              return (
                <Box sx={{ p: 1 }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 2px 8px #e0e0e0' }}>
                    <thead>
                      <tr style={{ background: '#f5f5f5' }}>
                        <th style={{ padding: '10px', border: '1px solid #e0e0e0', fontWeight: 700, fontSize: 15, color: '#222', textAlign: 'left', color: "white" }}>Field</th>
                        <th style={{ padding: '10px', border: '1px solid #e0e0e0', fontWeight: 700, fontSize: 15, color: '#222', textAlign: 'left', color: "white" }}>Update Data</th>
                        <th style={{ padding: '10px', border: '1px solid #e0e0e0', fontWeight: 700, fontSize: 15, color: '#222', textAlign: 'left', color: "white" }}>Previous Data</th>
                        <th style={{ padding: '10px', border: '1px solid #e0e0e0', color: "white" }}> Select All
                          <Checkbox
                            checked={selectAll}
                            onChange={(e) => handleSelectAll(e, fields)}
                            style={{ color: "white" }}
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {fields.map((row, idx) => (
                        <tr key={idx} style={{ background: idx % 2 === 0 ? '#fafbfc' : '#fff' }}>
                          <td style={{ padding: '10px', border: '1px solid #e0e0e0', fontWeight: 600, color: '#333', minWidth: 120 }}>{row.label}</td>
                          <td style={{ padding: '10px', border: '1px solid #e0e0e0', color: '#1976d2', fontWeight: 500 }}>{row.update || 'N/A'}</td>
                          <td style={{ padding: '10px', border: '1px solid #e0e0e0', color: '#333', fontWeight: 500 }}>{row.prev || 'N/A'}</td>
                          <td style={{ padding: '10px', border: '1px solid #e0e0e0', textAlign: "center" }}>
                            <Checkbox
                              checked={selectedRows.includes(idx)}
                              onChange={() => handleRowSelect(idx, fields)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
              );
            })()}
          </Box>
            :
            <Box>
              {schoolDataBasedOnId && schoolDataBasedOnId[0]?.schoolId ? <div>
                <div className="row mb-2 mt-1">
                  <div className="col-md-6">
                    <b> School Id:</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.schoolId || "N/A"}
                  </div>
                  <div className="col-md-6">
                    <b> School Name: </b>{schoolDataBasedOnId && schoolDataBasedOnId[0]?.schoolName || "N/A"}
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <b>E-Mail :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.email || "N/A"}
                  </div>
                  <div className="col-md-6">
                    <b>Created At :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.createdAt
                      ? new Date(schoolDataBasedOnId[0].createdAt).toLocaleDateString('en-GB', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                      })
                      : "N/A"}
                  </div>

                </div>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <b>Customer Type :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.customerTypeName || "N/A"}
                  </div>
                  <div className="col-md-6">
                    <b>School Type :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.schoolTypeName || "N/A"}
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <b>Decision Maker name :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.makerName || "N/A"}
                  </div>
                  <div className="col-md-6">
                    <b>Decision Maker Contact :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.makerContact || "N/A"}
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <b>Decision Maker Role :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.roleName || "N/A"}
                  </div>
                  <div className="col-md-6">
                    <b>Board :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.boardName || "N/A"}
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <b>Medium : </b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.mediumName || "N/A"}
                  </div>
                  <div className="col-md-6">
                    <b> Grade :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.grade_names || "N/A"}
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <b>Route Name : </b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.routeName || "N/A"}
                  </div>
                  <div className="col-md-6">
                    <b> Party Source :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.partySourceName || "N/A"}
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <b>School Start Time :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.start_time ? formatTime12(schoolDataBasedOnId[0].start_time) : "N/A"}
                  </div>
                  <div className="col-md-6">
                    <b>School End Time :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.end_time ? formatTime12(schoolDataBasedOnId[0].end_time) : "N/A"}
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <b>Strength :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.strength || "N/A"}
                  </div>
                  <div className="col-md-6">
                    <b> Transporter Name :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.transporter_name || "N/A"}
                  </div>

                </div>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <b>Address :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.AddressLine1 || "N/A"}
                  </div>
                  <div className="col-md-6">
                    <b>Pincode :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.Pincode || "N/A"}
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <b> District :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.District || "N/A"}
                  </div>

                  <div className="col-md-6">
                    <b>State :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.State || "N/A"}
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <b> Updated By :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.updatedByName || "N/A"}
                  </div>
                  <div className="col-md-6">
                    <b> Updated At :</b>{" "}
                    {schoolDataBasedOnId && schoolDataBasedOnId[0]?.updatedAt
                      ? new Date(schoolDataBasedOnId[0].updatedAt)
                        .toISOString()
                        .slice(0, 19)       // "2025-08-26T09:03:31"
                        .replace("T", " ")  // "2025-08-26 09:03:31"
                      : "N/A"}
                  </div>

                </div>
                <div className="row mb-2">

                </div>
              </div>
                :
                <div>
                  <div className="row mb-2 mt-1">
                    <div className="col-md-6">
                      <b> Distributor Id:</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.distributorID || "N/A"}
                    </div>
                    <div className="col-md-6">
                      <b> Distributor Name: </b>{schoolDataBasedOnId && schoolDataBasedOnId[0]?.DistributorName || "N/A"}
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <b>E-Mail :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.email || "N/A"}
                    </div>
                    <div className="col-md-6">
                      <b>Created At :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.createdAt
                        ? new Date(schoolDataBasedOnId[0].createdAt).toLocaleDateString('en-GB', {
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric'
                        })
                        : "N/A"}
                    </div>

                  </div>
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <b>Decision Maker name :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.makerName || "N/A"}
                    </div>
                    <div className="col-md-6">
                      <b>Decision Maker Contact :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.makerContact || "N/A"}
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <b>Decision Maker Role :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.roleName || "N/A"}
                    </div>
                    <div className="col-md-6">
                      <b>Address :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.AddressLine1 || "N/A"}
                    </div>
                  </div>
                  <div className="row mb-2">

                    <div className="col-md-6">
                      <b>Pincode :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.Pincode || "N/A"}
                    </div>
                    <div className="col-md-6">
                      <b> District :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.District || "N/A"}
                    </div>
                  </div>
                  <div className="row mb-2">


                    <div className="col-md-6">
                      <b>State :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.State || "N/A"}
                    </div>
                    <div className="col-md-6">
                      <b> Updated By :</b> {schoolDataBasedOnId && schoolDataBasedOnId[0]?.updatedByName || "N/A"}
                    </div>
                  </div>
                  <div className="row mb-2">

                    <div className="col-md-6">
                      <b> Updated At :</b>{" "}
                      {schoolDataBasedOnId && schoolDataBasedOnId[0]?.updatedAt
                        ? new Date(schoolDataBasedOnId[0].updatedAt)
                          .toISOString()
                          .slice(0, 19)       // "2025-08-26T09:03:31"
                          .replace("T", " ")  // "2025-08-26 09:03:31"
                        : "N/A"}
                    </div>

                  </div>
                  <div className="row mb-2">

                  </div>
                </div>}
            </Box>
          }
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="success"
            onClick={() => {
              let data = rowDataOfModal?.data;
              if (typeof data === 'string') {
                try { data = JSON.parse(data); } catch (e) { data = {}; }
              }
              let distributor = data?.distributor;
              if (typeof distributor === 'string') {
                try { distributor = JSON.parse(distributor); } catch (e) { distributor = distributor; }
              }
              console.log(distributor, "distributordistributor")
              const safeRender = (value, field) => {
                console.log(value, field);
                if (field === 'distributor') {
                  if (value && typeof value === 'object' && 'name' in value) {
                    return value.name || 'N/A';
                  }
                  if (typeof value === 'string') return value || 'N/A';
                  return 'N/A';
                }
                if (value == null) return 'N/A';
                if (typeof value === 'object') {
                  if (Array.isArray(value)) return value.join(', ');
                  if (value.name) return value.name;
                  return JSON.stringify(value);
                }
                return value;
              };
              const getNameById = (list, id, nameKey, idKey) => {
                if (!id || !Array.isArray(list)) return id || 'N/A';
                const found = list.find(item => String(item[idKey]) === String(id));
                return found ? found[nameKey] : id;
              };
              const fields = [
                { label: 'School ID', update: rowDataOfModal?.partyData?.schoolId, prev: schoolDataBasedOnId[0]?.schoolId },
                { label: 'School Name', update: safeRender(data.schoolName), prev: schoolDataBasedOnId[0]?.schoolName },
                { label: 'Email', update: safeRender(data.email), prev: schoolDataBasedOnId[0]?.email },
                { label: 'Board', update: getNameById(dropdownData.board, data.board, 'boardName', 'boardId'), prev: getNameById(dropdownData.board, schoolDataBasedOnId[0]?.boardName, 'boardName', 'boardId') },
                { label: 'Grade', update: getNameById(dropdownData.grade, data.grade, 'gradeName', 'gradeId'), prev: getNameById(dropdownData.grade, schoolDataBasedOnId[0]?.grade_names, 'gradeName', 'gradeId') },
                { label: 'Medium', update: getNameById(dropdownData.medium, data.medium, 'mediumName', 'mediumTableId'), prev: getNameById(dropdownData.medium, schoolDataBasedOnId[0]?.medium, 'mediumName', 'mediumTableId') },
                { label: 'Contact Person Role', update: getNameById(dropdownData.makerRole, data.makerRole, 'roleName', 'contactPersonRoleId'), prev: getNameById(dropdownData.makerRole, schoolDataBasedOnId[0]?.roleName, 'roleName', 'contactPersonRoleId') },
                { label: 'Contact Person Name', update: safeRender(data.makerName), prev: schoolDataBasedOnId[0]?.makerName },
                { label: 'Contact Person Number', update: safeRender(data.makerContact), prev: schoolDataBasedOnId[0]?.makerContact },
                { label: 'Distributor', update: safeRender(distributor, 'distributor'), prev: schoolDataBasedOnId[0]?.DistributorName },
                { label: 'Address Line 1', update: safeRender(data.addressLine1), prev: schoolDataBasedOnId[0]?.AddressLine1 },
                { label: 'Address Line 2', update: safeRender(data.addressLine2), prev: schoolDataBasedOnId[0]?.AddressLine2 },
                { label: 'Pincode', update: safeRender(data.pincode), prev: schoolDataBasedOnId[0]?.Pincode },
              ];
              let output = [];
              if (selectAll) {
                output = fields.map((row, idx) => {
                  let updateValue = row.update;
                  if (row.label === 'Board') updateValue = data.board;
                  if (row.label === 'Grade') updateValue = data.grade;
                  if (row.label === 'Distributor') updateValue = distributor?.id || distributor.name;
                  return { idx, label: row.label, prev: row.prev, update: updateValue };
                });
              } else {
                output = selectedRows.map(idx => {
                  let updateValue = fields[idx].update;
                  if (fields[idx].label === 'Board') updateValue = data.board;
                  if (fields[idx].label === 'Grade') updateValue = data.grade;
                  if (fields[idx].label === 'Distributor') updateValue = distributor?.id || distributor.name;
                  return { idx, label: fields[idx].label, prev: fields[idx].prev, update: updateValue };
                });
              }
              updatePartyBModal(output);
            }}
            disabled={selectedRows?.length <= 0}
          >Update</Button>
          <Button onClick={() => {
            setOpenPartyBModal(false);
            setSelectedRows([]);
            setSelectAll(false);
          }} variant="contained">Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openReleaseDialog} onClose={() => setOpenReleaseDialog(false)} fullWidth>
        <DialogTitle>Release Location</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Remark"
            type="text"
            fullWidth
            variant="outlined"
            value={releaseReason}
            onChange={(e) => setReleaseReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenReleaseDialog(false); setReleaseReason(""); }} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmRejectRelease} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}